export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker-legacy.b9538d03.worker.js");
}
